<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">在线评估</div>
        </div>
        <div class="con">
            <div class="title">
                澳大利亚技术移民评分表
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="测试题"></el-step>
                <el-step title="个人信息"></el-step>
                <el-step title="提交成功"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">提交</el-button>
            </div>
            <!-- <div class="con">
                <div class="text">
                    <p>欢迎迎进入小白都能看得懂系列之-澳洲技术移民打分表2025(在线自测)。澳洲技术移民，目前主要有三个类别:189独立技术移民，190州担保技术移民，491偏远地区技术移民。</p>
                    <div class="border">
                        <p>年龄超过44岁没有申请资格:</p>
                        <p>雅思4个7以上才有加分;</p>
                        <p>申请人的职业必须出现在 MLTS5L清单 或 STSOL清单 或 ROL清单 上:</p>
                        <p>澳大利亚需要做职业评估。申请人的职业必须通过澳大利亚的专业评估机构进行职业评估后，才能被澳大利亚移民局认可</p>
                    </div>
                    <p>澳大利亚自2012年7月1日起，引进了邻居KIWI家的EOI系统，同样，将申请过程分为了两部分:</p>
                    <p>第一部分:EOI Pool,即候选池(lnvitation to Apply Pool)，澳洲技术移民打分表满分140分，满65分即可入选;</p>
                    <p>第二部分:ITA(lnvitation to
                        Apply)，即申请获邀，澳大利亚移民局会根据每个职业的配额情况，根据分数高低从池子里捞出候选人。配额不够时，录取分数会走高;配额有空余时，分数则走低。
                    </p>
                    <p>目前执行的是2019年11月15日更新的打分表，最后一次更新是2020年3月17日(细则更新)。</p>
                    <p>澳洲189类190类与491类都需要达到65分才有资格申请，另外，491类是一个为期5年的临时移民签证，需要在偏远地区至少工作3年以后才能转永居。</p>
                    <p>澳大利亚技术移民评分，总分为140分，通过分为65分。</p>
                </div>
            </div> -->
        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <p class="score">您的评分：<span>{{ totalScore }}</span>分</p>
                <div class="step-1">
                    <div class="input-title"><span>*</span>姓名</div>
                    <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>邮箱</div>
                    <el-input placeholder="请输入邮箱" v-model="form.email"></el-input>
                    <div class="input-title">手机号</div>
                    <el-input placeholder="请输入手机号" v-model="form.mobile"></el-input>
                    <div class="input-title"><span>*</span>微信号</div>
                    <el-input placeholder="请输入微信号" v-model="form.wx_code"></el-input>
                    <div class="input-title">留言</div>
                    <el-input placeholder="请输入留言" v-model="form.about"></el-input>
                    
                    <div class="input-title">附件</div>
                    <el-radio v-model="form.reportType" label="1">上传图片</el-radio>
                    <el-radio v-model="form.reportType" label="2">上传文件</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">点击上传</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                只能上传 {{ form.reportType == 1 ? 'png、jpg' : "rar、zip、xls、xlsx、doc、docx" }} 文件
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">返回上一步</el-button>
                <el-button type="primary" class="btn" @click="subFn">提交</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                您的信息已提交，稍后我们会通过邮箱联系您
            </p>
            <el-button type="primary" class="btn" @click="stepActive = 0">重新测试</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [{
                title: '基本评分',
                children: [{
                    name: '年龄',
                    type: 'radio',
                    tip: '',
                    active: [],
                    option: [{
                        name: '18-24岁',
                        score: 25
                    }, {
                        name: '25-32岁',
                        score: 30
                    }, {
                        name: '33-39岁',
                        score: 25
                    }, {
                        name: '40-44岁',
                        score: 15
                    }, {
                        name: '45岁以上',
                        score: 0
                    }]
                }, {
                    name: '学历',
                    type: 'radio',
                    tip: '',
                    active: [],
                    option: [{
                        name: '博士',
                        score: 20
                    }, {
                        name: '学士/硕士',
                        score: 15
                    }, {
                        name: '专科(diploma/certificate)',
                        score: 10
                    }, {
                        name: '职业评估机构认可的其他学历',
                        score: 10
                    }, {
                        name: '无',
                        score: 0
                    }]
                }, {
                    name: '英语',
                    type: 'radio',
                    tip: '',
                    active: [],
                    option: [{
                        name: '雅思4个8',
                        score: 20
                    }, {
                        name: '雅思4个7',
                        score: 10
                    }, {
                        name: '雅思4个6',
                        score: 0
                    },]
                }, {
                    name: '澳州以外工作经验',
                    type: 'radio',
                    tip: '',
                    active: [],
                    option: [{
                        name: '8-10年',
                        score: 15
                    }, {
                        name: '5-7年',
                        score: 12
                    }, {
                        name: '3-4年',
                        score: 5
                    }, {
                        name: '0-2年',
                        score: 0
                    }]
                }]
            }, {
                title: '澳洲本土属性加分',
                children: [{
                    name: "澳洲工作经验",
                    type: 'radio',
                    tip: '',
                    active: [],
                    option: [{
                        name: '8-10年',
                        score: 20
                    }, {
                        name: '5-7年',
                        score: 15
                    }, {
                        name: '3-4年',
                        score: 10
                    }, {
                        name: '0-2年',
                        score: 5
                    }]
                }, {
                    name: '澳洲学历',
                    type: 'checkbox',
                    active: [],
                    tip: "*专业年又称职业年，澳洲职业年指对于顺利在澳洲完成学业，但因为移民分数不够的留学生，如果想移民澳洲，就可以考虑就读1年的职业年培训课程(Professional Year)",
                    option: [{
                        name: '研究生学位(研究型硕士/博士)',
                        score: 10
                    }, {
                        name: '2年全日制学习',
                        score: 5
                    }, {
                        name: '偏远地区学习',
                        score: 5
                    }, {
                        name: '专业年 *',
                        score: 5
                    }]
                }, {
                    name: '担保评分',
                    type: 'checkbox',
                    active: [],
                    tip: '',
                    option: [{
                        name: '190州担保',
                        score: 5
                    }, {
                        name: '491偏远地区担保(州担保或亲属担保)',
                        score: 10
                    }]
                }]
            }, {
                title: '其他加分',
                children: [{
                    name: '婚姻评分',
                    type: 'radio',
                    active: [],
                    tip: '',
                    option: [{
                        name: '单身 或 配偶为澳洲公民/永居居民',
                        score: 10
                    }, {
                        name: '配偶雅思4个6且通过职业评估',
                        score: 10
                    }, {
                        name: '配偶雅思4个6无职业评估',
                        score: 5
                    }]
                }, {
                    name: '社区语言',
                    type: 'checkbox',
                    active: [],
                    tip: '*澳洲移民社区语言(Credentialed Community Language Test)就是移民到澳洲的外国人在社区使用的语言，包括普通话和广东话等。大部分澳洲移民都会参加此考试以获得5分加分。目前主办方NAATI协会组织的考试形式是网上考试，所以是可以在海外参加的。',
                    option: [{
                        name: '澳洲社区语言学习(CCL) *',
                        score: 5
                    }]
                }]
            }],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 3,
                reportType: '2'
            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("只能上传一个文件");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("上传成功");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('请输入姓名')
                return
            }
            if (!this.form.email) {
                this.$message.error('请输入邮箱')
                return
            } 
            if (!this.form.wx_code) {
                this.$message.error('请输入微信号')
                return
            }
            this.$http.review_add3({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                wx_code: this.form.wx_code,
                reviewFileUrl: this.file_url
            }).then(res => {
                console.log(res, '------')
                this.$message.success('提交成功')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            let totalScore = 0;
            this.questionList.forEach(questionItem => {
                if (!Array.isArray(questionItem.children)) return;
                questionItem.children.forEach(child => {
                    const optionScoreMap = child.option.reduce((map, option) => {
                        const validScore = Number(option.score) || 0;
                        map[option.name] = validScore;
                        return map;
                    }, {});
                    switch (child.type) {
                        case 'radio':
                            totalScore += optionScoreMap[child.active] || 0;
                            break;
                        case 'checkbox':
                            child.active.forEach(activeName => {
                                totalScore += optionScoreMap[activeName] || 0;
                            });
                            break;
                        default:
                            console.warn(`未处理的题型：${child.type}`, child);
                            break;
                    }
                });
            });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 150px auto 300px;
        font-size: 25px;
        text-align: center;
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }

        .question-list:nth-child(2n) {
            border-left: 1px solid #ccc;
        }

        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/zh/evaluateEoi.vue